module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection copyright"
  }, [_c('p', {
    staticClass: "noindent_j4"
  }, [_vm._v("Copyright © 2006 by William Bearden")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("ISBN 978-1-6251-7155-9")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j1"
  }, [_vm._v("Published by Arcadia Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("Charleston, South Carolina")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j1"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j1"
  }, [_vm._v("Library of Congress Catalog Card Number: 2005935860")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j1"
  }, [_vm._v("For all general information contact Arcadia Publishing at:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("Telephone 843-853-2070")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("Fax 843-853-0044")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("E-mail "), _c('a', {
    attrs: {
      "href": "mailto:sales@arcadiapublishing.com"
    }
  }, [_vm._v("sales@arcadiapublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("For customer service and orders:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j"
  }, [_vm._v("Toll-Free 1-888-313-2665")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_j1"
  }, [_vm._v("Visit us on the Internet at "), _c('a', {
    attrs: {
      "href": "http://www.arcadiapublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.arcadiapublishing.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 60
// module chunks = 0